module.exports = __webpack_public_path__ + "img/t-shirt-printer.2996b697.png";